import React from 'react';
import classNames from 'classnames';
import CreateTagIcon from '../../../image/create-tag-blue.svg';
import css from './create-first-group-tag.module.scss';
import {
	CreateFirstTagPopup,
} from '../../../widgets/templates/private-template-tag-group-panel/ui/dropdown/create-first-tag';
import { useCreateTagModal } from '../../../hooks/useCreateTagModal';
import { TagGroupType } from '../../../entities/template/private-template-tag-group/model/types';

interface CreateFirstGroupTagProps {
	groupId: string,
	onCreateTag: (name: string) => Promise<any>,
	bindTag: (data: { groupId: string; tags: number[] }) => Promise<any>,
	forceRerender?: () => void,
	modalRef?: React.RefObject<HTMLDivElement>,
}

export const CreateFirstGroupTag = ({
	groupId,
	onCreateTag,
	bindTag,
	forceRerender,
	modalRef,
}: CreateFirstGroupTagProps) => {
	const {
		isCreateModalOpen,
		createModalRef,
		closeModal,
		handleCreateTagAction,
		handleModalClick,
	} = useCreateTagModal(groupId);

	const bindCreatedTag = async (name: string) => {
		const res = await onCreateTag(name);
		if (res && groupId && groupId !== TagGroupType.tagsWithoutGroup) {
			await bindTag({ groupId, tags: [res.id] });
		}
		forceRerender && forceRerender();
	};

	return (
		<div className={css.wrapper}>
			<div
				className={css.options}
				onClick={handleCreateTagAction}
				onKeyDown={handleCreateTagAction}
				tabIndex={0}
				role="button"
				aria-label="Создать тег"
			>
				<p className={css.create_tag}>Создать тег</p>
				<div className={css.create_tag}>
					<div className={css.create_tag_icon}>
						<CreateTagIcon />
					</div>
					{isCreateModalOpen && (
						<div
							ref={createModalRef}
							onClick={handleModalClick}
							onKeyDown={handleCreateTagAction}
							tabIndex={0}
							role="button"
							className={classNames(css.createTag_modal, {
								[css.visible]: isCreateModalOpen, // Добавляем класс, если isCreateModalOpen === true
							})}
						>
							<CreateFirstTagPopup
								isCreateModalOpen={isCreateModalOpen}
								groupId={groupId}
								onClose={closeModal}
								bindCreatedTag={bindCreatedTag}
								modalRef={modalRef}
								isNeedUpdatePos
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
